import { ChevronLeft, ChevronRight } from "lucide-react";

export default function AdminTablePagination({ page, totalPages, totalItems, pageSize, onPageChange }) {
  if (totalItems <= pageSize) return null;

  const firstItem = (page - 1) * pageSize + 1;
  const lastItem = Math.min(totalItems, page * pageSize);

  return (
    <div className="admin-table-pagination flex items-center justify-between gap-3 border-t px-4 py-3">
      <span className="text-xs text-neutral-500 dark:text-neutral-400">
        Showing {firstItem}-{lastItem} of {totalItems}
      </span>
      <div className="flex items-center gap-1.5">
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1} className="theme-icon-button" aria-label="Previous page">
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="min-w-16 text-center text-xs font-medium text-neutral-600 dark:text-neutral-300">{page} / {totalPages}</span>
        <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages} className="theme-icon-button" aria-label="Next page">
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
